export const modularHousesNavItems = {
  model: 'Modèle 3D',
  options: 'Choix',
};

export const description =
  "Les maisons modulaires offrent un design inhabituel et une vie confortable pour votre famille. Que ce soit à Cáceres, à Tolède ou à Barcelone, ce type d'habitation s'intègre facilement dans n'importe quel paysage. Nous produisons des bâtiments modulaires modernes, économes en énergie et préfabriqués. Votre maison, entièrement prête pour une résidence permanente, tiendra compte de tous vos besoins. Vous avez la possibilité de choisir l'option avec finition intérieure clé en main.";
